import React, { useCallback, useEffect, useState } from 'react'
import InputTextField from '../../../../../components/InputTextField/InputTextField'
import { Stack, Typography } from '@mui/material'
import { useAppDispatch, useAppSelector } from '../../../../../store/utils/hooks'
import { actionSaveOnboardingData, selectOnboardingData } from '../../../../../store/slices/user/userSlice'
import { Trans } from 'react-i18next'
import { validatePassword } from '../../../../../utils/Validators/Validators'

type PasswordConfirmationProps = {
	onPasswordChange: (value: boolean) => void
	disabled?: boolean
	onFocus?: () => void
}

export default function PasswordConfirmation({ onPasswordChange, disabled, onFocus }: PasswordConfirmationProps) {
	const dispatch = useAppDispatch()
	const onboardingData = useAppSelector(selectOnboardingData)
	const [repeatedPassword, setRepeatedPassword] = useState<string>('')
	const [validPassword, setValidPassword] = useState<boolean>(true)
	const setPassword = useCallback((password: string) => dispatch(actionSaveOnboardingData({ password })), [dispatch])

	useEffect(() => {
		if (repeatedPassword !== onboardingData?.password) {
			setValidPassword(false)
			onPasswordChange(false)
			return
		}

		if (!validatePassword(onboardingData?.password)) {
			setValidPassword(false)
			onPasswordChange(false)
			return
		}
		setValidPassword(true)
		onPasswordChange(true)
	}, [onPasswordChange, onboardingData?.password, repeatedPassword])

	return (
		<Stack gap="16px">
			<Stack direction="row" gap="16px">
				<InputTextField
					required
					type="password"
					i18nLabel="onboarding.payment.password_label"
					name="password_label"
					onChange={(e) => setPassword(e.target.value)}
					onFocus={onFocus}
					value={onboardingData?.password}
					disabled={disabled}
					sx={{ flexGrow: 1 }}
				/>
				<InputTextField
					required
					type="password"
					i18nLabel="onboarding.payment.confirm_password_label"
					name="confirm_password_label"
					onChange={(e) => setRepeatedPassword(e.target.value)}
					onFocus={onFocus}
					value={repeatedPassword}
					disabled={disabled}
					sx={{ flexGrow: 1 }}
				/>
			</Stack>
			<Typography fontSize="10px" color={validPassword ? '' : 'red'}>
				<Trans i18nKey="onboarding.payment.password_hint_description" />
			</Typography>
		</Stack>
	)
}
